import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import axios from 'axios';

import CatalogItem from '../../utils/components/CatalogItem';
import { Box, Divider, Typography, Grid, Container, Button } from '@mui/material';
import FormatoCatalogo from '../formatos/FormatoCatalogo';

function CatalogoImpresion() {

    const auth = useSelector((state) => state.auth);
    let navigate = useNavigate();

    const [products, setProducts] = useState([]);
    const [printVersion, setPrintVersion] = useState(true);
    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' }); // for custom alert message

    useEffect(() => {
        document.title = 'Catalogo de Impresión 3D';
        getProducts();
    }, [])

    const getProducts = async () => {
        try {
            const res = await axios.post('/api/products/catalog', { data: ['Impresion 3D'] });
            if (res.status === 200) {
                setProducts(res.data);
            }
        } catch (error) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al obtener los productos, intentelo mas tarde', severity: 'error' } });
            console.log(error);
        }
    }

    return (

        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            <Box className='text-center' >
                <Typography variant='h4' style={{ fontWeight: 700 }}>Catálogo de Impresión 3D</Typography>
            </Box>
            <Button size='small' variant='outlined' onClick={() => navigate('/catalogos')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
            <Button size='small' variant='outlined' sx={{ ml: 3 }} onClick={() => setPrintVersion(printVersion => !printVersion)}><i className='fad fa-eye'></i> &nbsp;&nbsp;{printVersion ? 'Versión digital' : 'Versión para imprimir'}</Button>
            <Divider variant="middle" className='my-3' />
            {
                printVersion ? <FormatoCatalogo products={products} company={auth.user.company} catalog={'impresion'} /> :
                    <Grid container spacing={3}>
                        {products.map((card, i) => {
                            return (
                                <Grid item key={i} xs={12} sm={6} md={3}>
                                    <CatalogItem
                                        name={card.nombre}
                                        image={card.imagen}
                                        info={card.descripcion}
                                        color={'primary.main'}
                                        btnColor={'primary'}
                                    />
                                </Grid>
                            )
                        })}
                    </Grid>
            }
            <br></br>
        </Container>
    )
}

export default CatalogoImpresion;